import React, { FC } from 'react';
import { SpheraNotification, SpheraNotificationGroup } from '@sphera-cloud/component-ui-reactjs';

export interface NotificationType {
  isOpen: boolean;
  type: string;
  text: string;
}

interface NotificationProps {
  notification: NotificationType;
  setNotification: (notification: any) => void;
  position?: {
    [key: string]: string | number;
  };
}

export const defaultNotification = { isOpen: false, type: '', text: '' };

export const ToastNotification: FC<NotificationProps> = ({
  notification,
  setNotification,
  position = {
    top: 70,
    left: '50%',
    transform: 'translateX(-50%) perspective(0)',
  },
}) => {
  return (
    <SpheraNotificationGroup position={position}>
      {notification.isOpen && (
        <div data-testid="notification">
          <SpheraNotification
            closable={true}
            type={notification.type}
            text={notification.text}
            onClose={() => setNotification(defaultNotification)}
          />
        </div>

      )}
    </SpheraNotificationGroup>
  );
};
